export const Permission = [
  'Administrators',
  'User Manager',
  'Operator',
  'Reader',
  'Analyst',
  'Senior Operator',
  'Support',
  'MLN-HK',
]
